/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
  DeleteApiV1LocationCountriesCountryidLangsIdPathParams,
  DeleteApiV1LocationCountriesCountryidLangsId401,
  DeleteApiV1LocationCountriesCountryidLangsId404,
  DeleteApiV1LocationCountriesCountryidLangsId500,
} from "../../types/locationCountryLangController/DeleteApiV1LocationCountriesCountryidLangsId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1LocationCountriesCountryidLangsId } from "../../clients/locationCountryLangController/deleteApiV1LocationCountriesCountryidLangsId.ts";

export const deleteApiV1LocationCountriesCountryidLangsIdMutationKey = () =>
  [{ url: "/api/v1/location/countries/:countryId/langs/:id" }] as const;

export type DeleteApiV1LocationCountriesCountryidLangsIdMutationKey =
  ReturnType<typeof deleteApiV1LocationCountriesCountryidLangsIdMutationKey>;

export function deleteApiV1LocationCountriesCountryidLangsIdMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteApiV1LocationCountriesCountryidLangsIdMutationKey();
  return mutationOptions<
    DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesCountryidLangsId401
      | DeleteApiV1LocationCountriesCountryidLangsId404
      | DeleteApiV1LocationCountriesCountryidLangsId500
    >,
    {
      countryId: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
      id: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["id"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ countryId, id }) => {
      return deleteApiV1LocationCountriesCountryidLangsId(
        countryId,
        id,
        config,
      );
    },
  });
}

/**
 * @description Remove permanentemente uma tradução (idioma) de país. **(Requer Authorization para autenticação)**
 * @summary Excluir idioma do país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries/:countryId/langs/:id}
 */
export function useDeleteApiV1LocationCountriesCountryidLangsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1LocationCountriesCountryidLangsId401
        | DeleteApiV1LocationCountriesCountryidLangsId404
        | DeleteApiV1LocationCountriesCountryidLangsId500
      >,
      {
        countryId: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
        id: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["id"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteApiV1LocationCountriesCountryidLangsIdMutationKey();

  const baseOptions =
    deleteApiV1LocationCountriesCountryidLangsIdMutationOptions(
      config,
    ) as UseMutationOptions<
      DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1LocationCountriesCountryidLangsId401
        | DeleteApiV1LocationCountriesCountryidLangsId404
        | DeleteApiV1LocationCountriesCountryidLangsId500
      >,
      {
        countryId: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
        id: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["id"];
      },
      TContext
    >;

  return useMutation<
    DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesCountryidLangsId401
      | DeleteApiV1LocationCountriesCountryidLangsId404
      | DeleteApiV1LocationCountriesCountryidLangsId500
    >,
    {
      countryId: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
      id: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["id"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1LocationCountriesCountryidLangsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1LocationCountriesCountryidLangsId401
      | DeleteApiV1LocationCountriesCountryidLangsId404
      | DeleteApiV1LocationCountriesCountryidLangsId500
    >,
    {
      countryId: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["countryId"];
      id: DeleteApiV1LocationCountriesCountryidLangsIdPathParams["id"];
    },
    TContext
  >;
}
